import Rusha from 'rusha'
import { getErrorReporter } from '@healthshare/shared/platform/errorReporter'
import type { PlatformFile } from '@healthshare/shared/platform/file'

let rushaWorker: ReturnType<typeof Rusha.createWorker>
let queued: {
  [id: string]: {
    resolve: (hash: string) => void
    reject: (err: Error) => void
  }
} = {}

export async function hashFileSha1(file: PlatformFile) {
  return sha1FromArrayBuffer(await file.read())
}

/**
 * Hashes raw bytes on a Rusha Web Worker.
 *
 * Previously the browser `File` was posted to the worker directly and Rusha read
 * it there. Now the bytes are read first (PlatformFile.read) and the buffer is
 * posted instead, because React Native has no `File` -- and no Web Workers, which
 * is why CryptoAdapter exists for native to supply its own SHA-1. The digest is
 * identical either way; only where the file is read moved.
 */
export async function sha1FromArrayBuffer(bytes: ArrayBuffer) {
  if (!rushaWorker) { initWorker() }

  const msgId = Math.random().toString(36).substring(7)
  rushaWorker.postMessage({
    id: msgId,
    data: bytes,
  })


  return new Promise<string>((resolve, reject) => {
    queued[msgId] = { resolve, reject }
  })
}

function initWorker() {
  rushaWorker = Rusha.createWorker();

  rushaWorker.addEventListener('message', (e) => {
    if (e.data.id && queued[e.data.id]) {
      const { resolve, reject } = queued[e.data.id]
      if (e.data.error) {
        reject(new Error(e.data.error))
      } else {
        resolve(e.data.hash)
      }
      delete queued[e.data.id]
    }
  })

  rushaWorker.addEventListener('messageerror', (e) => {
    console.log('rusha message error', e)
    getErrorReporter().captureException(e)
  })
}
